module.exports = __webpack_public_path__ + "static/media/Quinn.3eff8988.jpg";